export enum CustomFeatureConfigKey {
  SkilledNeeds = 'skilled-needs',
  ADLNeeds = 'adl-needs',
  VisitDurationConstraint = 'visit-duration-constraint',
  DailyAuthorizedHoursConstraint = 'daily-authorized-hours-constraint',
  WeeklyAuthorizedHoursConstraint = 'weekly-authorized-hours-constraint',
  MonthlyAuthorizedHoursConstraint = 'monthly-authorized-hours-constraint',
  PriorAuthorizationRequest = 'prior-authorization-request',
  IsServicePlan = 'is-service-plan',
  AllowPAT = 'allow-pat',
  AllowSOC = 'allow-soc',
  AllowRecert = 'allow-recert',
  AllowFua = 'allow-fua',
  AllowROC = 'allow-roc',
  AllowDischarge = 'allow-discharge',
  AllowSupervisory = 'allow-supervisory',
  AreAideTasks = 'are-aide-tasks',
  HasStandardizedHours = 'has-standardized-hours',
  ExternallyDefinedPriorAuthorization = 'externally-defined-prior-authorization',
  CanDeleteVisitScheduleOnPage = 'can-delete-visit-on-schedule-page',
  PlotVisitsButton = 'plot-visits-button',
  F2FDateRequired = 'f2f-date-required',
  IsVisitServiceType = 'is-visit-service-type',
  IsShiftServiceType = 'is-shift-visit-service-type',
  DailyCareHoursConstraint = 'daily-care-hours-constraint',
  WeeklyCareHoursConstraint = 'weekly-care-hours-constraint',
  AcutePeriod = 'acute-period',
  HasTasksFrequency = 'has-tasks-frequency',
  IsMcoAllowed = 'is-mco-allowed',
  IsAcoAllowed = 'is-aco-allowed',
  Enforce30MinVisitsGap = 'enforce-30-min-visits-gap',
  AllowOverlappingVisitsAcrossPatients = 'allow-overlapping-visits-across-patients',
  StartCareWithoutAuthorization = 'start-care-without-authorization',
  SkilledServiceTypes = 'skilled-service-types'
}
